module.exports = __webpack_public_path__ + "static/urban9-3247f939800bb0a5891e30dfcca0c6b3.jpg";